import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import Field, { hasDataInFields } from '../../../../containers/PageBuilder/Field';
import SectionContainer from '../../../../containers/PageBuilder/SectionBuilder/SectionContainer';
import BlockBuilder from '../../../../containers/PageBuilder/BlockBuilder';

import css from './SectionArticleCustom.module.css';

const SectionArticleCustom = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    blocks = [],
    isInsideContainer = false,
    options,
    customClasses,
  } = props;

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);
  const hasBlocks = blocks?.length > 0;

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={classNames(defaultClasses.sectionDetails, customClasses.sectionDetails)}>
          <Field data={title} className={defaultClasses.title} options={fieldOptions} />
          <div className={css.description}>
            <FormattedMessage
              id="LandingPage.slogan"
              values={{ span: text => <span className={css.sloganHighlight}>{text}</span> }}
            />
          </div>
          <Field data={callToAction} className={defaultClasses.ctaButton} options={fieldOptions} />
        </header>
      ) : null}
      {hasBlocks ? (
        <div
          className={classNames(defaultClasses.blockContainer, css.articleMain, {
            [css.noSidePaddings]: isInsideContainer,
          })}
        >
          <BlockBuilder
            className={classNames(customClasses.block)}
            blocks={blocks}
            sectionId={sectionId}
            ctaButtonClass={defaultClasses.ctaButton}
            options={options}
          />
        </div>
      ) : null}
    </SectionContainer>
  );
};

export default SectionArticleCustom;
